import {FC} from 'react'
import classNames from 'classnames'
import {Tab} from 'components/ui/Tab'
import {useQuery} from 'hooks/graphql'
import {IS_SENT_DOCUMENT_CONTRACT} from '../../query'
import {useLocation} from 'react-router-dom'
import styles from './LinkTab.scss'

type LinkTabProps = {
  id: string | number
}

export const LinkTab: FC<LinkTabProps> = ({id}) => {
  const {pathname} = useLocation()
  const {data} = useQuery(IS_SENT_DOCUMENT_CONTRACT, {
    fetchPolicy: 'cache-and-network',
    variables: {id},
  })

  const isSentContract = data?.client?.document?.contractSent
  const client = data?.client
  const isShowContractTab = client?.planType === 'paid_plan' && client.isVerified

  return (
    <div className={classNames(styles.tabs, {[styles.withContract]: isShowContractTab})}>
      <Tab active={pathname === `/documents/${id}`} to={`/documents/${id}`}>
        書類プレビュー
      </Tab>
      <Tab active={pathname === `/documents/${id}/employees`} to={`/documents/${id}/employees`}>
        従業員一覧
      </Tab>
      {isShowContractTab && (
        <Tab
          active={pathname === `/documents/${id}/contracts`}
          to={`/documents/${id}/contracts`}
          disabled={!isSentContract}
        >
          電子契約一覧
        </Tab>
      )}
    </div>
  )
}
